import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { Box, useTheme, useMediaQuery } from "@mui/material";
import { BookkeeperMonthlyIcon } from "../../assets/Icon/headerCicon";

interface Prop {
  type: string;
  title: string;
  price: string;
  btnLoading: boolean;
  handleClick: any;
}

const BookkeeperPlanCard = ({
  type,
  title,
  price,
  btnLoading,
  handleClick,
}: Prop) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 1,
        width: "230px",
        border: "0.6px solid rgba(167, 199, 234, 0.50)",
        borderRadius: "10px",
        background: "linear-gradient(180deg, #EAF1FA 0%, #F6F9FD 100%)",
        padding: "10px 10px",
        marginTop: "20px",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyItems: "center",
          gap: 1,
        }}
      >
        <div
          style={{
            border: "0.2px solid #A7C7EA",
            backgroundColor: "#fff",
            borderRadius: "200px",
            width: "54px",
            height: "54px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: 16,
          }}
        >
          <BookkeeperMonthlyIcon />
        </div>
        <p
          style={{
            fontSize: "16px",
            textAlign: "center",
            width: "100%",
            fontWeight: 500,
            marginTop: 14,
          }}
        >
          {title} Plan
        </p>
        <div
          style={{
            display: "flex",
          }}
        >
          <p
            style={{
              fontSize: "30px",
              textAlign: "center",
              width: "100%",
              fontWeight: "bold",
              color: "#2977CC",
              marginTop: 6,
            }}
          >
            ${price}
          </p>
          <p
            style={{
              fontSize: "12px",
              color: "#2c3034",
              fontWeight: 500,
              marginLeft: 5,
              textAlign: "end",
              display: "flex",
              alignItems: "end",
              paddingBottom: 10,
            }}
          >
            /
            <span
              style={{
                marginLeft: 5,
              }}
            >
              {type}
            </span>
          </p>
        </div>
        <button
          style={{
            margin: "auto",
            padding: "13px 65px",
            borderRadius: "8px",
            background: btnLoading
              ? "#BDBDBD"
              : "linear-gradient(to right, #2977CC, #1D538F)",
            color: "white",
            border: "none",
            fontSize: isMobile ? "14px" : "14px",
            fontWeight: 600,
            marginTop: isMobile ? "14px" : "18px",
            marginBottom: "10px",
            cursor: "pointer",
            minWidth: isMobile ? "140px" : "auto",
            height: "44px",
            opacity: btnLoading ? 0.7 : 1,
          }}
          onClick={btnLoading ? undefined : handleClick}
          disabled={btnLoading}
        >
          {btnLoading ? (
            <span
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 8,
              }}
            >
              <CircularProgress size={22} sx={{ color: "#fff" }} />
            </span>
          ) : (
            "Buy Now"
          )}
        </button>
      </div>
    </Box>
  );
};

export default BookkeeperPlanCard;
